import { Outlet } from 'react-router-dom';

import closeIcon from '../../assets/svg/closeIcon.svg';
import facebook from '../../assets/svg/facebook.svg';
import hamburgerIcon from '../../assets/svg/hamburguer.svg';
import logo from '../../assets/svg/horizontalLogo.svg';
import instagram from '../../assets/svg/instagram.svg';
import linkedin from '../../assets/svg/linkedin.svg';
import youtube from '../../assets/svg/youtube.svg';

import Footer from '../../components/Footer';
import Header from '../../components/Header';

export function DefaultLayout() {
  return (
    <>
      <div>
        <Header
          logo={logo}
          closeIcon={closeIcon}
          hamburgerIcon={hamburgerIcon}
          hasRecord="Já tem cadastro?"
          login="Faça seu login"
        />
        <main>
          <Outlet />
        </main>
      </div>
      <Footer
        logo={logo}
        instagramSvg={instagram}
        youtubeSvg={youtube}
        facebookSvg={facebook}
        linkedinSvg={linkedin}
        titleSocialMedias="Acompanhe a gente"
        legalText="Grupo Casas Bahia S.A. - CNPJ: 33.041.260/0652-90 - Rua Florida, 1970 - São Paulo - SP - CEP: 04565-001"
        FrequentQuestions="Dúvidas frequentes"
        FrequentQuestionsLink="https://suportemarketplace.viavarejo.com.br/pt-BR/lojista/"
      />
    </>
  );
}
